<template>
  <div class="text-xs-center">
    <div class="message-div my-5">
      {{ $t('error_has_occured') }}
    </div>
    <v-btn color="primary" @click="returnToHomepage">{{ $t('return_home') }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'Error',

  data() {
    return {};
  },

  methods: {
    returnToHomepage() {
      window.location = `${window.origin}${process.env.VUE_APP_BASE_URL}`;
    },
  },
};
</script>

<style scoped>

</style>
